/**
 * 能耗接口
 */
import Axios from '@/components/api/axios.js'

export default {
   getPowerMonthResult(time,produceValue,success,failure) {
   		Axios.post('/history/getPowerMonthResult.do', {
   			time,produceValue
		},success,failure)
   },
	/**
	 * 生产看板分项能耗
	 * @param time
	 * @param dateType
	 * @param success
	 * @param failure
	 */
	getEnergyTypeRanking(time,dateType,success,failure) {
		Axios.post('/energyType/getEnergyTypeRanking.do', {
			time,dateType
		},success,failure)
	},
	/**
	 * 生产看板用电概况
	 * @param dateTime
	 * @param success
	 * @param failure
	 */
	getUnitUseTimePowerByDate(dateTime,success,failure) {
		Axios.post('/power/getUnitUseTimePowerByDate.do', {
			dateTime
		}, success, failure)
	},
	/**
	 * 获取组的尖峰平谷数据
	 * @param {Integer} deviceNo 设备no
	 * @param {Long} bgTime 开始时间
	 * @param {Long} endTime 结束时间
	 */
	getDevicePG(deviceNos, bgTime, endTime, success, failure) {
		Axios.post('/power/getDevicePG.do', {
			deviceNos,
			bgTime,
			endTime
		}, success, failure)
	},
	/**
	 * 获取组的尖峰平谷数据
	 * @param {Integer} classNo 组no
	 * @param {Long} bgTime 开始时间
	 * @param {Long} endTime 结束时间
	 */
	getClassPG(classNo, bgTime, endTime, success, failure) {
		Axios.post('/power/getClassPG.do', {
			classNo,
			bgTime,
			endTime
		}, success, failure)
	},
	/**
	 * 全胜定制查询月峰平谷数据
	 * @param {Integer} unitId 
	 * @param {Integer} dataType 
	 * @param {Integer} atListDay 月最后一天 
	 */
	getqueshengUnitPG(unitId,dataType,atListDay,success, failure) {
		Axios.post('/power/getqueshengUnitPG.do', {
			unitId,
			dataType,
			atListDay,
		}, success, failure)
	},
	/**
	 * 查询变量在指定日期区间内的差值
	 * @param {String} variableName 变量名称
	 * @param {Long} bgTime 开始时间
	 * @param {Long} endTime 结束时间
	 */
	getVariableValueSub(variableName, bgTime, endTime, success, failure) {
		Axios.post('/power/getVariableValueSub.do', {
			variableName,
			bgTime,
			endTime
		}, success, failure)
	},
	/**
	 * 查询组某年的电费分布
	 * @param {Integer} classNo 组no
	 * @param {Long} time 时间
	 */
	getClassUseMoneyByYear(classNo, time, success, failure) {
		Axios.post('/power/getClassUseMoneyByYear.do', {
			classNo,
			time
		}, success, failure)
	},
	/**
	 * 查询单位日负荷
	 * @param {String} unitId 单位id，不传默认当前单位
	 * @param {Long} time 时间
	 */
	getUnitDayLoadValues(unitId, time, success, failure) {
		Axios.post('/power/getUnitDayLoadValues.do', {
			unitId,
			time
		}, success, failure)
	},
	/**
	 * 查询单位日负荷(可传设备no)
	 * @param {String} unitId 单位id，不传默认当前单位
	 * @param {Long} time 时间
	 * @param {Long} deviceNos 设备nos
	 */
	getUnitDayLoadValuesNos(unitId, time,deviceNos, success, failure) {
		Axios.post('/power/getUnitDayLoadValues.do', {
			unitId,
			time,
			deviceNos,
		}, success, failure)
	},
	/**
	 * 查询日最大负荷
	 * @param {String} unitId 单位id，不传默认当前单位
	 * @param {Long} time 时间
	 */
	getDayMaxLoad(unitId, time, success, failure) {
		Axios.post('/power/getDayMaxLoad.do', {
			unitId,
			time
		}, success, failure)
	},
	/**
	 * 查询日最大负荷(可按设备过滤)
	 * @param {String} unitId 单位id，不传默认当前单位
	 * @param {Long} time 时间
	 */
	getDayMaxLoadDeviceNos(unitId, time,deviceNos, success, failure) {
		Axios.post('/power/getDayMaxLoad.do', {
			unitId,
			time,
			deviceNos,
		}, success, failure)
	},
	/**
	 * 查询日最大需量
	 * @param {String} unitId 单位id，不传默认当前单位
	 * @param {Long} time 时间
	 */
	getDayMaxLoadDemand(unitId, time, success, failure) {
		Axios.post('/power/getDayMaxLoadDemand.do', {
			unitId,
			time
		}, success, failure)
	},
	/**
	 * 查询月最大需量
	 * @param {String} unitId 单位id，不传默认当前单位
	 * @param {Long} time 时间
	 */
	getMonthMaxLoadDemand(unitId, time, success, failure) {
		Axios.post('/power/getMonthMaxLoadDemand.do', {
			unitId,
			time
		}, success, failure)
	},
	/**
	 * 获取单位的负荷变量
	 * @param {String} unitId 单位id，不传默认当前单位
	 */
	getLoadFromnameByUnitId(unitId, success, failure) {
		Axios.post('/power/getLoadFromnameByUnitId.do', {
			unitId,
		}, success, failure)
	},
	/**
	 * 获取单位的负荷变量(可按设备过滤)
	 * @param {String} unitId 单位id，不传默认当前单位
	 * @param {String} deviceNos 设备nos
	 */
	getLoadFromnameByUnitIdDeviceNos(unitId,deviceNos, success, failure) {
		Axios.post('/power/getLoadFromnameByUnitId.do', {
			unitId,
			deviceNos,
		}, success, failure)
	},
	/**
	 * 查询能耗变量
	 * @param {String} unitId 单位id，不传默认当前单位
	 */
	getPowerFromnameByUnitId(unitId, success, failure) {
		Axios.post('/power/getPowerFromnameByUnitId.do', {
			unitId
		}, success, failure)
	},
	/**
	 * 月最大值
	 * @param {String} unitId 单位id，不传默认当前单位
	 * @param {Long} time 时间
	 */
	getMonthMaxLoad(unitId, time, success, failure) {
		Axios.post('/power/getMonthMaxLoad.do', {
			unitId,
			time
		}, success, failure)
	},
	/**
	 * 月最大值（可根据设备no过滤）
	 * @param {String} unitId 单位id，不传默认当前单位
	 * @param {Long} time 时间
	 * @param {Long} deviceNos 设备no
	 */
	getMonthMaxLoadDeviceNos(unitId, time,deviceNos, success, failure) {
		Axios.post('/power/getMonthMaxLoad.do', {
			unitId,
			time,
			deviceNos,
		}, success, failure)
	},
	/**
	 * 查询设备用电量
	 * @param {String} deviceNos 设备no集合，逗号隔开
	 * @param {Long} bgTime 开始时间
	 * @param {Long} endTime 结束时间
	 */
	getDeviceUsePowerByDate(deviceNos, bgTime, endTime, success, failure) {
		Axios.post('/power/getDeviceUsePowerByDate.do', {
			deviceNos,
			bgTime,
			endTime
		}, success, failure)
	},
	/**
	 * 查询单位设备能耗变量差值排行
	 * @param {String} unitId 单位id，传空值默认当前用户单位
	 * @param {Long} bgTime 开始时间，时间戳格式
	 * @param {Long} endTime 结束时间，时间戳格式
	 * @param {Integer} listSize 取差值排行前几位
	 */
	getPowerDifferenceRanking(unitId, bgTime, endTime, listSize, success, failure) {
		Axios.post('/power/getPowerDifferenceRanking.do', {
			unitId,
			bgTime,
			endTime,
			listSize
		}, success, failure)
	},
	/**
	 * 查询单位设备月用电量及差值，按差值排行
	 * @param {String} unitId 单位id，传空值默认当前用户单位
	 * @param {Long} time 时间，时间戳格式
	 * @param {Integer} listSize 取差值排行前几位
	 */
	getMonthDifferenceRanking(unitId, time, listSize, success, failure) {
		Axios.post('/power/getMonthDifferenceRanking.do', {
			unitId,
			time,
			listSize
		}, success, failure)
	},
	/**
	 * 获取单位用电量
	 * @param {String} unitId 单位id，传空值默认当前用户单位
	 * @param {Long} bgTime 开始时间，时间戳格式
	 * @param {Long} endTime 结束时间，时间戳格式
	 */
	getUnitUsePowerByDate(unitId, bgTime, endTime, success, failure) {
		Axios.post('/power/getUnitUsePowerByDate.do', {
			unitId,
			bgTime,
			endTime
		}, success, failure)
	},
	/**
	 *获取组的尖峰平谷月度数据 
	 */
	getClassPGByMonth(month, classNo, success, failure) {
		Axios.post('/power/getClassPGByMonth.do', {
			month,
			classNo
		}, success, failure)
	},
	/**
	 * 获取月的每天用电量数据
	 * /huapu/getClassPGByMonthForHuaPu.do(旧接口)post
	 *  /cost/findCostFromMonth(新接口)get
	 * 
	 */
	getClassPGByMonthForHuaPu(timeStamp, unitId, success, failure) {
		Axios.post('/huapu/getClassPGByMonthForHuaPu.do', {
			timeStamp,
			unitId,
		}, success, failure)
	},
	/**
	 * 查询单位的用电量（看板使用）
	 * unitId(单位id)
	 * deviceNos(设备no)，多个用逗号隔开
	 */
	getUnitUsePower(unitId, deviceNos, success, failure) {
		Axios.post('power/getUnitUsePower.do', {
			unitId,
			deviceNos
		}, success, failure)
	},
	/**
	 * 查询设备月能耗
	 * /huapu/getClassPGByMonthForHuaPu.do(旧接口)post
	 * /cost/findCostFromMonth(新接口)get
	 */
	getClassPGByMonthForHuaPudviceNos(unitId,timeStamp,deviceNos,success, failure) {
		Axios.post('/huapu/getClassPGByMonthForHuaPu.do', {
			unitId,
			timeStamp,
			deviceNos,
		}, success, failure)
	},
	/**
	 * 导出峰平谷表格
	 */
	exportDevicePG(bgTime, endTime,deviceNos,success, failure) {
		Axios.post('/power/exportDevicePG.do', {
			bgTime,
			endTime,
			deviceNos,
		}, success, failure)
	},
	/**
	 * 单位峰平谷数据
	 */
	getUnitPG(unitId,bgTime, endTime,success, failure) {
		Axios.post('/power/getUnitPG.do', {
			unitId,
			bgTime,
			endTime,
		}, success, failure)
	},
	/**
	 *全胜定制 (获取上月和本月需量的变量)
	 * 
	 */
	getMonthDemandvariable(unitId,monthType,success,failure){
		Axios.post('/power/getMonthDemandvariable.do', {
			unitId,
			monthType,
		}, success, failure)
	},
	
}